import { useTheme } from "@/lib/theme";
import { Monitor, Moon, Sun } from "lucide-react";

const OPTIONS = [
  { key: "system", icon: Monitor, label: "Sistem" },
  { key: "light", icon: Sun, label: "Terang" },
  { key: "dark", icon: Moon, label: "Gelap" },
];

export default function ThemeToggle() {
  const { mode, setTheme } = useTheme();
  return (
    <div className="inline-flex items-center gap-0.5 border border-border rounded-full p-0.5" data-testid="theme-toggle">
      {OPTIONS.map((o) => {
        const Icon = o.icon;
        const active = mode === o.key;
        return (
          <button
            key={o.key}
            onClick={() => setTheme(o.key)}
            aria-label={`Tema ${o.label}`}
            data-testid={`theme-${o.key}`}
            className={`w-11 h-11 md:w-9 md:h-9 flex items-center justify-center rounded-full transition-colors ${active ? "bg-primary text-primary-foreground" : "text-muted-foreground hover:text-foreground"}`}
          >
            <Icon className="w-4 h-4" strokeWidth={2} />
          </button>
        );
      })}
    </div>
  );
}
